<template>
    <div>
        <button-secondary @click="open()">
            <template slot="icon"><i class="fa fa-plus"></i></template> Konferenzraum hinzufügen
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">Konferenzraum hinzufügen</template>

                <input-text v-model="name" class="mb-4">
                    Name des Konferenzraums
                </input-text>

                <input-text v-model="details" class="mb-8">
                    Details
                    <template v-slot:helper>
                        z.B. Tel. Nummer, Ohne Fenster, ...
                    </template>
                </input-text>

                <input-text v-model="persons" class="mb-8" type="number">
                    Maximale Anzahl an Personen
                </input-text>

                <div class="flex justify-end">
                    <button-primary @click="store"><template slot="icon"><i class="fa fa-plus"></i></template> Konferenzraum hinzufügen</button-primary>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonSecondary from "./UI/ButtonSecondary";
import Modal from "./Modal";
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";

export default {
    name: "ConferenceRoomCreate",

    components: {InputText, ButtonPrimary, Modal, ButtonSecondary},

    data: () => ({
        showModal: false,
        name: '',
        persons: 0,
        details: ''
    }),

    methods: {
        open() {
            this.name = '';
            this.persons = 0;
            this.details = '';
            this.showModal = true;
        },
        store() {
            window.axios.post('/admin/conference_rooms', {
                name: this.name,
                persons: this.persons,
                details: this.persons,
            }).then(() => {
                this.showModal = false;
                this.$emit('created');
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
